import { Component } from '@angular/core';
import { ExecutiveService } from '../../../services';
import { ChatBotV2DataService } from '../../../services/chat-bot-v2/chat-bot-v2.data.service';

@Component({
  selector: 'app-chat-bot-asesor-v2-header',
  templateUrl: './chat-bot-asesor-v2-header.component.html',
})
export class ChatBotAsesorV2HeaderComponent {
  constructor(
    public chatBotV2DS: ChatBotV2DataService,
    public executiveS: ExecutiveService
  ) { }

  async nuevoChat() {
    this.chatBotV2DS.eliminarChat();
    this.chatBotV2DS.tabActive.next(0);
  }

}
